import academyReworkings from './academyReworkings';
import { LanguageResourse } from '../en';

const LANGUAGE_FILE_TR: LanguageResourse = {
	studyRules: { main: 'Study Rules' },
	academyReworkings,
	header: {
		toolbar: {
			report: 'Rapor',
			certificates: 'Sertifikalar',
			education: 'Eğitim',
			news: 'Haberler',
			gradebook: 'Not defteri',
			market: 'Market',
			appointment: 'Randevu',
			student: 'öğrenci',
			emptyVideo: 'Eğitim videosu henüz eklenmedi',
			billing: 'Faturalandırma',
		},
	},
	certificates: {
		main: 'Sertifikalar',
		details: 'Detaylar',
		download: 'İndir',
		requirements: 'Sertifika Gereklilikleri',
		finalTestGrade: 'Final testinden en az %70 puan',
		homeworkPercent: 'Tamamlanan ödev sayısının en az %75’i',
		scoreGrade: 'Sınıf çalışmaları için ortalama en az %70',
		overallGrade: 'Ödevler için ortalama not en az %70',
		downloadText: 'Sertifikayı indir:',
		emptyDataTitle: 'Başarılarınız için yer🏆',
		averageNull: 'Programı tamamladığınızda sertifikanız burada görünecek! Başarılar💪',
	},
	pwa: {
		push: 'PWA bildirimleri',
		installBanner: {
			campus: 'Kampüse dön',
			install: 'PWA’yı yükle',
			tutorial: 'Video eğitimini izle',
		},
	},
	scorm: {
		rotateHint: 'Görevi tamamlamak için telefonunuzu yatay konuma çevirin veya dersi bilgisayarınızda açın — böyle daha kullanışlıdır 😉',
	},
	market: {
		main: 'Market',
	},
	report: {
		yearsOfStudy: 'Eğitim yılları',
		gradeNumber: '{{count}}. sınıf',
		aboutMe: {
			strengths: 'Güçlü yönler',
			personalityQualities: 'Kişisel özellikler',
			interests: 'İlgi alanları',
		},
		goals: {
			main: 'Hedefler',
			specifycResults: 'Somut sonuç',
			continuation: 'Devam',
			breakeDown: 'Hedefe nasıl ulaşacağınızı adım adım açıklayın',
			addSteps: 'Hedefe adımlar ekleyin',
			describeSubGoal: 'Hedefe ulaşmak için adımlar',
		},
		individuality: {
			main: 'Bireysellik',
			hobbies: 'Hobiler',
			values: 'Değerler',
			talents: 'Yetenekler',
		},
		achievements: {
			main: 'Başarılar',
			academicAchievements: 'Akademik başarılar',
			mentorSupport: 'Mentor desteği',
			documents: {
				title: 'Belgeler',
				subTitle: 'PDF dosyası',
				files: {
					gyms: 'Spor Salonları Hakkında Bilgi - Spor Salonları',
					onlineLearning: 'Geçici Çevrimiçi Eğitime Geçiş Prosedürü',
					poolRules: 'Havuz Ziyaret Kuralları',
					handbook: 'TIS: Öğrenci ve Veli El Kitabı',
					faq: 'TIS SSS',
				},
			},
			myEducationPlannerPortfolio: 'Portföyüm',
			emptyData: 'Yıl boyunca yeni veriler eklenecektir.',
			projects: 'Projeler',
			knowledge: 'Bilgi',
			files: {
				one: '{{count}} dosya',
				few: '{{count}} dosya',
				many: '{{count}} dosya',
			},
			tooltip: 'Bu bloğun temel amacını açıklayan bazı bilgiler',
			addFileModal: {
				title: 'Dosya yükleme',
				placeholderName: 'Dosya adını girin',
				placeholderType: 'Hangi alandan başarı',
				selectFile: 'Dosya seç',
				drop: 'Yüklemek için dosyayı bırakın',
				selectOrDrop: 'Bir dosya seçin veya buraya sürükleyip bırakın',
			},
		},
	},
	programs: {
		main: 'Programlar',
		seeAll: 'Tümünü gör',
		empty: 'Henüz herhangi bir programınız yok',
		name: 'Ad',
		lessons: {
			one: '{{count}} ders',
			few: '{{count}} ders',
			many: '{{count}} ders',
			deadlineExpired: 'Son tarih geçti',
		},
		currentLearningFlow: {
			currentDirection: 'Mevcut yön',
			directionTitle: '{{direction}} · {{grade}}. sınıf öğrenim yolu',
			creditsActive: '{{total}} kredinin {{active}} tanesi aktif',
			instalmentPlan: 'Mevcut taksit planı',
			nextCharge: 'Sonraki tahsilat: <b>{{date}} · {{amount}}</b>',
		},
	},
	program: {
		teacher: 'Öğretmen',
		yourProgress: 'İlerlemeniz',
		inProgress: 'Devam ediyor',
		overview: 'Program Genel Bakışı',
		checking: 'Değerlendiriliyor',
		completed: 'Notlandırıldı',
		rejected: 'Reddedildi',
		visited: 'Katıldı',
		planned: 'Planlanan dersler',
		missed: 'Kaçırıldı',
		noStatus: 'Durum seçilmedi',
		reviewed: 'İncelendi',
		courseProgress: 'Kurs ilerlemesi',
		workOnThePlatform: 'Genel not',
		missedClasses: 'Kaçırılan dersler',
		missedLessons: 'Kaçırılan dersler',
		workingOff: 'Bir eğitmenle telafi edilecek dersler',
		learnt: 'Uygulanan dersler',
		courseTextBooks: 'Kurs ders kitapları',
		totalLessons: 'Toplam ders',
		lessonOpenIn: 'Ders {{date}} tarihinde açılacak',
		checkingEmptyLessonsTitle: 'Görünüşe göre henüz incelenecek bir şey yok',
		checkingEmptyLessonsDescription: 'Ödevinizi tamamlayın, burada görünecektir 😉',
		completedEmptyLessonsTitle: 'Henüz tamamlanmış ders yok',
		completedEmptyLessonsDescription: 'Derslerinizi bitirdiğinizden ve inceleme için gönderdiğinizden emin olun. Zaten yaptıysanız, öğretmeniniz değerlendirene kadar biraz bekleyin! 😊',
		review: 'İncele',
		nonGradedAssignment: 'Notlandırılmayan Ödev',
		activeEmptyLessonsTitle: 'Burada aktif ders yok.',
		activeEmptyLessonsDescription: 'Görünüşe göre tüm ödevlerinizi zaten tamamladınız, böyle devam edin! Ya da belki sıradaki dersler için henüz zaman gelmedi ⌛️',
		resetEmptyLessonsTitle: 'Burada bir şey yok.',
		resetEmptyLessonsDescription: 'Görünüşe göre tüm dersler ilk denemede iyi gidiyor, böyle devam edin!💥',
		certificateToolTip: 'Dosyayı indirmek için tüm görevleri tamamlayın',
		certificateDownload: 'Sertifikayı indir',
		professionalPathDownload: 'Mesleki Yol',
		moreLessons: 'Daha fazla ders',
	},
	lesson: {
		discoverYourself: 'Ders Genel Bakışı',
		nextLesson: 'Sonraki Ders',
		emptyTeacherComment: 'Öğretmen yorumları bu bölümde görüntülenecektir',
		emptyDetails: 'Bu blok ders materyallerini görüntüleyecektir',
		files: 'Dosyalar',
		books: 'Kitaplar',
		links: 'Faydalı bağlantılar',
		zoomLink: 'Zoom Bağlantısı',
		zoomId: 'Zoom kimliği',
		zoomAccessCode: 'Zoom erişim kodu',
		miroLink: 'Miro Bağlantısı',
		complete: 'Ders başarıyla tamamlandı',
		errorComplete: 'Ders gönderilirken bir hata oluştu',
		emptyTitle: 'Ders yakında kullanılabilir olacak',
		teacherFeedback: 'Öğretmen Geri Bildirimi',
		discussionBoard: 'Tartışma Panosu Bağlantısı',
		testRules: {
			test: 'Test',
			attention: 'Dikkat!',
			videoSurveillance: 'Video Gözetimi Devam Ediyor',
			description: 'Bu test, adalet ve şeffaflığı sağlamak amacıyla video gözetimi altında gerçekleştirilmektedir.',
			title: 'Test Kuralları:',
			monitoring: 'Video gözetimi zorunludur',
			monitoringDescription: 've test boyunca devam eder.',
			prohibited: 'Yasaklanan işlemler:',
			prohibitedDescription: 'harici materyaller kullanmak, başkalarıyla iletişim kurmak veya sekmeler arasında geçiş yapmak.',
			timeLimited: 'Test sürelidir',
			timeLimitedDescription: '— geçerli bir neden olmadan testi yarıda kesmeyin.',
			mustAgree: 'Devam etmek için kuralları kabul etmelisiniz.',
			disagreeDescription: 'Kabul etmezseniz teste giremezsiniz',
			doNotAgree: 'Kabul Etmiyorum',
			agree: 'Kuralları Kabul Et',
		},
		rubric: {
			showMore: 'Daha fazla göster',
			tableTitle: 'Değerlendirme rubriği',
			criteria: 'Kriterler',
			mark: 'Puan',
		},
	},
	resources: {
		main: 'Kaynaklar',
		new: 'YENİ',
		inProcess: 'İşlemde',
		completed: 'Tamamlandı',
		titleOrAuthor: 'Kitap adı veya yazarı',
		emptySearchTitle: '"{{search}}" için sonuç bulunamadı',
		emptySearchSubTitle: 'Hatalı bir sorgu girmiş olabilirsiniz. Yazımı kontrol edin.',
		length: {
			one: '{{count}} kitap',
			few: '{{count}} kitap',
			many: '{{count}} kitap',
		},
		emptyBooksTitle: 'Henüz kitap eklenmedi',
		emptyBooksDescription: 'Daha fazla öğrenim kaynağı yakında geliyor!',
		emptyMaterialTitle: 'Materyaller şu anda mevcut değil',
		emptyMaterialDescription: 'Yakında yeni kaynaklar bekleyin!',
	},
	news: {
		main: 'Haberler',
		latest: 'Son Haberler',
		all: 'Tüm Haberler',
		popularity: 'Popülerlik',
		wasTheArticleUseful: 'Makale faydalı mıydı?',
		emptyDataTitle: 'Şu anda haber yok',
		emptyDataDescription: 'Yakında bir güncelleme için takipte kalın!',
	},
	consultations: {
		main: 'Danışmanlıklar',
		start: 'Başlat',
		freeSlot: 'Boş zaman aralığı',
		notEnoughFreeSlots: 'Yeterli ardışık boş zaman aralığı yok',
		chooseSessionDuration: 'Oturum süresini seçin',
		consultationLimit: 'Danışmanlık limiti öğrencinin planına göre belirlenir',
		hintMessage: 'Bir sonraki uygun 90 dakikalık danışmanlık {{date}} tarihinden sonradır',
		unpurchasedModal: {
			welcome: '👋 Talented platformuna hoş geldiniz!',
			intro: 'Burada olmanızdan memnuniyet duyuyoruz. Yöneticimiz kısa süre içinde sizinle iletişime geçerek başlamanıza ve her şeyi ihtiyaçlarınıza göre uyarlamanıza yardımcı olacak.',
			message: 'Bu arada, platformu keşfetmekten çekinmeyin — tüm bölümlere ve özelliklere göz atın!',
		},
		campus: {
			welcome: '👋 Campus platformuna hoş geldiniz!',
			intro: 'Başlamak için lütfen metodoloğumuzla tanıtım danışmanlığı rezervasyonu yapın.',
			goTo: 'Şuraya gidin:',
			timeMeeting: 'bölümü ve toplantı için uygun bir zaman seçin.',
			bookButton: 'Danışmanlık rezervasyonu yap',
		},
		selfPacedModal: {
			welcome: '🚀 Harekete geçme zamanı!',
			intro: 'Yolculuğunuz şimdi başlıyor. İlk dersler “Programlar” bölümünde zaten mevcut — hemen başlayın!',
			bookButton: '🔘 Programlara git',
		},
		consultationModal: {
			successTitle: '👍 İlk danışmanlığınızı başarıyla rezerve ettiniz!',
			successMessage: 'Bir sonraki adım, ilkinden 7 gün sonra gerçekleşmesi gereken ikinci danışmanlığınızdır. Bu oturum, öğrenim yolunuzu belirlemeye ve size kişiselleştirilmiş öneriler sunmaya yardımcı olacaktır.',
			successMessageSelfPaced: 'Toplantı bağlantısı danışmanlık kartında zaten mevcut ve ayrıca e-postanıza da gönderildi.',
			reminder: '📅 Uygun bir zamanı önceden ayırtmak için şimdi rezervasyon yapabilirsiniz.',
			reminderSelfPaced: 'Orada sizi görmeyi dört gözle bekliyoruz!',
		},
		googleCalendarMeetTitle: 'Talented danışmanlığı',
	},
	appointment: {
		main: 'Randevu',
		lyceum: 'Randevu',
		talented: 'Danışmanlıklar',
		chooseAProgram: 'Bir program seçin',
		chooseATeacher: 'Bir öğretmen seçin',
		missedLesson: 'Kaçırılan dersler: {{count}}',
		location: 'Konum',
		group: 'Sınıf',
		program: 'Ders',
		teacher: 'Öğretmen',
		timeZone: 'Çalışma programı Kyiv saatine göre gösterilmektedir',
		visualGuide: {
			sectionDescription: 'Bu bölüm, kaçırılan ders sayısını azaltmanıza yardımcı olacaktır.',
			usefulInfo: 'Telafi hakkında bilinmesi faydalı olanlar:',
			sessionDuration: '1 telafi oturumunun süresi: 20 dakika.',
			sessionFormat: 'Format: çevrimiçi.',
			bookingSteps: 'Kayıt için aşağıdaki adımları izleyin:',
			selectTeacher: 'Listeden bir öğretmen seçin',
			selectWeek: 'Telafi için kayıt olmak istediğiniz haftayı takvimde seçin',
			bookSlot: 'Takviminizde “Boş” olarak işaretlenmiş bölümlerden uygun bir gün ve saat rezerve edin. Bu, bu zamanın rezervasyona açık olduğu anlamına gelir. Bilgileri doldurduğunuzda, güncellenmiş bir durum ve rezervasyonunuzun farklı bir rengini fark edeceksiniz',
			note: 'Lütfen dikkat: ',
			bookingRestriction: '“Boş” yazısının yanındaki 🔐 işareti, istenen saate 12 saatten az kaldığı için rezervasyonun mümkün olmadığı anlamına gelir.',
			sessionLinkInfo: 'Telafiye erişim bağlantısı, rezerve ettiğiniz zaman diliminde mevcut olacaktır: katılım bilgilerini almak için tekrar tıklayın.',
		},
		lyceumVisualGuide: {
			sectionDescriptionTitle: 'İletişime her zaman açığız ve size uygun bir zamanda Lyceum ekibiyle konuşma fırsatına sahip olmanın sizin için ne kadar önemli olduğunu anlıyoruz ',
			sectionDescription: 'Bu bölüm, Lyceum temsilcileriyle toplantı planlamak için güvenilir aracınızdır: uygun bir zaman ve öğretmen seçin, tam ihtiyacınız olduğunda destek alın 😊',
			usefulInfo: 'Toplantılar hakkında bilinmesi faydalı olanlar:',
			sessionDuration: '1 toplantının süresi: 20 dakika.',
			selectSubject: 'Listeden bir konu seçin',
			selectTeacher: 'Ardından listeden bir öğretmen seçin',
			selectWeek: 'Bir toplantı planlamak istediğiniz haftayı takvimde seçin',
			sessionLinkInfo: 'Toplantı bağlantısı, rezerve ettiğiniz zaman diliminde mevcut olacaktır. Katılım bilgilerini almak için tekrar tıklayın.',
			meetingSuccessMessage: 'Size sorunsuz bir rezervasyon süreci ve değerli, verimli toplantılar dileriz!',
		},
		googleCalendarTooltip: {
			title: 'Oturumunuzu kaçırmayın',
			message: 'Bu etkinliği Google Takvim’inize ekleyin ve tam zamanında bir hatırlatma alın.',
			cta: 'Google Takvim’e ekle',
		},
		youWantToCancel: 'Randevuyu iptal etmek istediğinizden emin misiniz?',
		confirmCancelAppointment: 'Evet, randevuyu iptal et',
		rejectCancelAppointment: 'Hayır, geri dön',
		wait: 'Bekleyin,',
	},
	talented: {
		visualGuide: {
			sectionDescription: 'Bu bölüm, size uygun bir tarih ve saat seçmenize yardımcı olacak bir kariyer rehberliği uzmanıyla toplantı ve danışmanlıkları planlamada güvenilir yardımcınızdır.',
			usefulInfo: 'Danışmanlıklar hakkında faydalı bilgiler:',
			sessionDuration: 'Danışmanlık süresi: 30 dakikadan 1 saat 30 dakikaya kadar',
			sessionFormat: 'Format: Zoom üzerinden çevrimiçi',
			bookingSteps: 'Rezervasyon yapmak için şu adımları izleyin:',
			selectTeacher: '“Boş” olarak işaretlenmiş uygun bir zaman seçin. Diğer tarihleri görmek için takvimi kullanın.',
			selectWeek: 'Seçilen zaman ve danışmanlık süresinin doğru olduğundan emin olun. Telefon numaranızı girin ve “Rezerve Et”e tıklayın.',
			bookSlot: 'Rezerve ettiğiniz zaman takvimde yeşil renkte vurgulanacaktır. Detayları görüntülemek ve toplantı bağlantısına erişmek için üzerine tıklayın. Mentor, seçilen tarih ve saatte katılacaktır.',
			note: 'Not, ',
			bookingRestriction: 'lütfen dikkat, “Boş” yazısının yanındaki 🔐 işareti, istenen saate 12 saatten az kaldığı için rezervasyonun mümkün olmadığı anlamına gelir.',
			sessionLinkInfo: 'Danışmanlık bağlantısı, rezerve ettiğiniz zaman diliminde mevcut olacaktır: katılım bilgilerini almak için tekrar tıklayın.',
		},
		orderNotification: {
			title: '🔒 Program kullanılamıyor',
			message: 'Bu program satın alınmadığı için kilitlidir.',
		},
	},
	gradeBook: {
		lesson: 'Ders',
		present: 'Mevcut',
		absent: 'Yok',
		late: '{{time}} dakika geç',
		online: 'Çevrimiçi',
		classWork: 'Sınıf çalışması',
		join: 'Katıl',
		homeWork: 'Ödev',
		homeTask: 'Ödev',
		ht: 'Ö/G',
		grades: 'Notlar',
		assesmentType: 'Değerlendirme türü',
		tisChange: 'Toronto Imperial School dersine erişiyorsunuz. Geçmek ister misiniz?',
		tisChangeButton: 'Haydi gidelim',
		comment: 'Yorum',
		emptyTitle: 'Bu dönem için planlanmış bir dersiniz bulunmuyor',
		emptyDescription: 'Becerilerinizi geliştirmeyi düşünün ',
		thematicGrade: 'Tematik not{{label}}',
		selectProgramTitle: 'Program Seç',
		selectProgramDescription: 'Notları görmek için bir program seçin',
		noGradesTitle: 'Not Yok',
		noGradesDescription: 'Seçilen dönem için not bulunmuyor',
		calendarView: 'Takvim görünümü',
		teacherLeftComment: 'Öğretmen yorum bıraktı',
		emptyDay: 'Bugün okul yok. Hak ettiğiniz dinlenmenin tadını çıkarın!',
		today: 'Bugün',
	},
	gradeBreakDown: {
		showWeekend: 'Hafta sonunu göster',
	},
	home: {
		main: 'Ana Sayfa',
		greeting: 'Merhaba, {{name}}!',
		greetingFallback: 'Merhaba!',
	},
	routes: {
		access: 'Erişim',
		auth: 'Yetkilendirme',
		home: 'Ana Sayfa',
		news: 'Haberler',
		resources: 'Kaynaklar',
		programs: 'Programlar',
		lessons: 'Dersler',
		report: 'Rapor',
		certificates: 'Sertifikalar',
		achievements: 'Başarılar',
		about: 'Hakkımda',
		strengths: 'Güçlü Yönler',
		goals: 'Hedefler',
		steps: 'Adımlar',
		create: 'Oluştur',
		portfolio: 'Portföy',
		individuality: 'Bireysellik',
		interests: 'İlgi Alanları',
		qualities: 'Kişisel Özellikler',
		appointments: 'Randevular',
		profile: 'Profil',
		gradebook: 'Not Defteri',
		month: 'Ay',
		chat: 'Sohbet',
		homework: 'Ödev',
		policies: 'Politikalar',
		market: 'Market',
		payment: 'Ödeme',
		onboarding: 'Oryantasyon',
		tests: 'Testler',
		dashboard: 'Panel',
		education: 'Eğitim',
		financial: 'Finans',
		students: 'Öğrenciler',
		b2b: 'B2B',
		results: 'Sonuçlar',
		resetPassword: 'Şifreyi Sıfırla',
	},
	profile: {
		main: 'Profil',
		parents: 'Veliler',
		location: 'Konum',
		class: 'Sınıf',
		language: 'Dil',
		changePassword: 'Şifreyi değiştir',
		resetPassword: 'Şifreyi sıfırla',
		changePasswordNotification: 'Yeni şifre kaydedildi',
		currentPasswordPlaceholder: 'Mevcut şifreyi girin',
		newPasswordPlaceholder: 'Yeni şifreyi girin',
		repeatNewPasswordPlaceholder: 'Yeni şifreyi tekrar girin',
		emailPlaceholder: 'E-posta*',
		maxSizeAvatarError: 'Dosya boyutu {{size}}MB sınırını aşıyor',
		typeAvatarError: 'Yalnızca resim dosyalarına izin verilir',
		clickOrDrop: 'İndirmek için tıklayın veya dosyayı buraya sürükleyip bırakın',
		dropFile: 'Yüklemek için dosyayı bırakın',
		english: 'İngilizce',
		ukrainian: 'Ukraynaca',
		information: 'Bilgi',
		myParents: 'Velilerim',
	},
	themeModal: {
		title: 'Tema ayarları',
		youAreResponsible: 'Temayı değiştirmekten siz sorumlusunuz; öğrenimi zorlaştırıyorsa varsayılan temayı kullanın.',
		concentration: 'Konsantrasyon',
		space: 'Uzay',
		image: 'Resim yükleniyor',
		changeBanner: 'Banner değiştiriliyor',
		gradient: 'Gradyan',
		main: 'Ana',
		text: 'Metin',
		reset: 'Varsayılana sıfırla',
	},
	notifications: {
		main: 'Bildirimler',
		important: 'Önemli',
		empty: 'Bildirim bulunmuyor',
		individual: 'Bireysel',
		general: 'Genel',
		markAllAsRead: 'Tümünü okundu olarak işaretle',
	},
	chat: {
		main: 'Sohbet',
	},
	homeWork: {
		main: 'Ödev',
		emptyDataTitle: 'Atanmış ödev yok',
		emptyDataSubTitle: 'Seçilen dönem için ödev bulunmuyor gibi görünüyor',
		emptyDataSubTitleForWeek: 'Önümüzdeki 7 gün için ödev bulunmuyor gibi görünüyor',
		lessonTopic: 'Ders Konusu',
		nextLesson: 'Sonraki ders {{date}}',
		homeworkStatus: 'Ödev durumu',
		new: 'Yeni',
		inProgress: 'Devam ediyor',
		checking: 'Değerlendiriliyor',
		done: 'Tamamlandı',
		seeAll: 'Tümünü gör',
		overdue: 'Süresi geçti',
	},
	policies: {
		main: 'Politikalar',
		emptyDataTitle: 'Politika bulunmuyor',
	},
	errorPage: {
		subTitle: '',
		goToPrograms: 'Programlara git',
		goToNews: 'Haberlere git',
		newVersionAvailable: 'Yeni bir sürüm mevcut. Sayfa yeniden yükleniyor...',
	},
	shared: {
		continue: 'Devam et',
		close: 'Kapat',
		viewResult: 'Sonucu görüntüle',
		copyLink: 'Bağlantıyı kopyala',
		moreOption: 'Diğer seçenek',
		shareViaEmail: 'E-posta ile paylaş',
		rememberMe: 'Beni hatırla',
		childAccount: 'Çocuğun hesabı',
		schoolAdministration: 'Okul yönetimi',
		back: 'Geri',
		todo: 'Yapılacak',
		complete: 'Dersi tamamla',
		sortBy: 'Sırala',
		comingSoon: 'Çok yakında...',
		latest: 'En son',
		addFile: 'Dosya Ekle',
		save: 'Kaydet',
		submit: 'Dersi gönder',
		submitTest: 'Gönder',
		logout: 'Çıkış yap',
		success: 'Başarılı!',
		day: 'Gün',
		week: 'Hafta',
		emptyDataTitle: 'İçerik eklemek üzerinde çalışıyoruz.',
		emptyDataSubTitle: 'Her şey yakında kullanılabilir olacak!',
		cancel: 'İptal',
		cancelCaps: 'İPTAL',
		delete: 'Sil',
		areYouSure: 'Emin misiniz?',
		youWantToDelete: 'Bu dosyayı silmek istiyorsunuz',
		somethingWentWrong: 'Bir şeyler yanlış gitti',
		tutorial: 'Öğretici',
		loading: 'Yükleniyor...',
		notifications: {
			default: 'Bildirim',
			success: 'Başarılı!',
			error: 'Hata!',
			warning: 'Uyarı!',
			info: 'Bilgi',
		},
		days: {
			one: 'Gün',
			few: 'Gün',
			many: 'Gün',
		},
		hours: {
			one: 'Saat',
			few: 'Saat',
			many: 'Saat',
		},
		minutes: {
			one: 'Dakika',
			few: 'Dakika',
			many: 'Dakika',
		},
		seconds: {
			one: 'Saniye',
			few: 'Saniye',
			many: 'Saniye',
		},
		date: 'Tarih',
		theme: 'Tema',
		subject: 'Konu',
		deadlineUntil: 'Son tarih {{date}}',
		deadlineWas: 'Son tarih {{date}}',
		confirm: 'Onayla',
		confirmCaps: 'ONAYLA',
		verifyYourself: 'Kendinizi doğrulayın',
		refresh: {
			button: 'Yenile',
			message: 'Yeni bir sürüm mevcut',
		},
		send: 'Gönder',
		phone: 'Telefon numarası',
		email: 'E-posta adresi',
		fullName: 'Ad Soyad',
		start: 'Başlat',
		dashboard: 'Panel',
		review: 'İncele',
		action: 'İşlem',
		noData: 'VERİ YOK',
		search: {
			placeholder: 'Ad, kimlik vb...',
			label: 'Ara',
		},
		pagination: {
			rowsPerPage: 'Sayfa başına satır:',
		},
		columns: {
			studentName: 'Öğrenci adı',
			emailAddress: 'E-posta adresi',
			grade: 'Sınıf',
			englishTest: 'İngilizce testi',
			talanted: 'Talented ',
			action: 'İşlem',
			status: 'Durum',
			group: 'Grup',
			program: 'Program',
			loa: 'İzin (LOA)',
		},
		filters: {
			default: 'FİLTRELER',
		},
		applyCaps: 'UYGULA',
		resetCaps: 'SIFIRLA',
		seeMore: 'Daha fazla gör',
		sendTestPush: 'Test bildirimi gönder (next7)',
		testPushSent: 'Test bildirimi gönderildi',
		pushTokenUpdated: 'Bildirim anahtarı güncellendi',
	},
	auth: {
		selectChildAccount: 'Çocuğun hesabını seçin',
	},
	tabs: {
		aboutMe: 'HAKKIMDA',
		achievement: 'BAŞARI',
		allLessons: 'TÜM DERSLER',
		todo: 'ATANDI',
		active: 'AKTİF',
		onChecking: 'DEĞERLENDİRİLİYOR',
		renew: 'YENİLE',
		completed: 'NOTLANDIRILDI',
		books: 'KİTAPLAR',
		materials: 'MATERYALLER',
		gradebook: 'NOT DEFTERİ',
		gradeBreakdown: 'NOT DÖKÜMÜ',
		classWork: 'SINIF ÇALIŞMASI',
		homeWork: 'ÖDEV',
		details: 'DETAYLAR',
		teacherComment: 'ÖĞRETMEN GERİ BİLDİRİMİ',
		pdfReport: 'PDF RAPORU',
	},
	validationMessages: {
		selectOneOption: 'Bir seçenek seçin',
		onlyOneOption: 'Yalnızca bir seçenek seçilebilir',
		selectAtLeastOne: 'En az bir seçenek seçin',
		passwordsNotMatch: 'Şifreler eşleşmiyor',
		mandatory: 'Alan zorunludur',
		fileRequired: 'Bir dosya eklenmesi gerekiyor',
		passwordMatch: 'Şifreler eşleşmelidir',
		minCharacters: {
			one: 'Şifre en az {{min}} karakter olmalıdır',
			few: 'Şifre en az {{min}} karakter olmalıdır',
			many: 'Şifre en az {{min}} karakter olmalıdır',
		},
		lowercaseLetter: 'Şifre en az bir küçük harf içermelidir',
		uppercaseLetter: 'Şifre en az bir büyük harf içermelidir',
		invalidEmail: 'Lütfen geçerli bir e-posta adresi girin',
		passwordMin: 'Şifre en az 4 karakter olmalıdır',
		login: {
			invalidEmail: 'Geçersiz e-posta adresi',
			passwordMin: 'Şifre en az 8 karakter olmalıdır',
		},
		confirmPassword: {
			passwordMin: 'Şifre en az 4 karakter olmalıdır',
			passwordsMustMatch: 'Şifreler eşleşmelidir',
		},
	},
	b2b: {
		studyPrograms: 'Eğitim programları',
		tuitionFees: 'Eğitim Ücretleri',
		freePrograms: 'Ücretsiz Programlar',
		dashboard: 'Panel',
		education: 'Eğitim',
		financial: 'Finansal',
		commissionStructure: 'Komisyon Yapısı',
		students: 'Öğrenciler',
		contactUs: 'Bize ulaşın',
		writeToUs: 'Sohbetten bize yazın',
		free: 'Ücretsiz',
		payment: 'Ücretler ve harçlar',
		all: 'Tümü',
		contactWithUs: 'Bizimle iletişime geçin',
		constUsModalDescription: 'Telefon numaranızı bırakın, uzmanımız size özel en uygun seçeneği bulmanız için <highlight>ücretsiz danışmanlık</highlight> verecek.',
		partnersPathway: {
			title: 'Başarıya Giden Ortaklık Yolu',
			step: 'Adım',
		},
		onboardingHub: {
			title: 'Başlangıç merkezi',
			step1Title: 'Sertifika ve Memorandum',
			step1Description: 'Sertifika alın ve özel öğrenci avantajları sunun',
			step2Title: 'Eğitim Programı',
			step2Description: 'Kolay öğrenim için araçlar ve örneklerle adım adım plan',
			step3Title: 'Finansal Motivasyon',
			step3Description: 'Getirdiğiniz her öğrenci için komisyon kazanın',
			step4Title: 'Öğrenci Davet Ederek Başlayın',
			step4Description: 'Öğrencileri kurslara katılmaya davet edin ve öğrenmeye başlayın',
			step5Title: 'İlk Grubunuzu Başlatın',
			step5Description: 'Kolay öğrenim için araçlar ve örneklerle adım adım plan',
			getIt: 'Al',
			detail: 'Detay',
			step: 'Adım',
		},
		video: {
			title: 'Video',
		},
		profile: {
			aboutMe: 'Hakkımda',
			firstName: 'Ad',
			lastName: 'Soyad',
			emailAddress: 'E-posta adresi',
			phoneNumber: 'Telefon numarası',
			country: 'Ülke',
			city: 'Şehir',
			institutionName: 'Kurumun adı',
			institutionType: 'Kurum türü',
			memorandum: 'Ortaklık Mutabakat Muhtırası (MOU)',
			officialPartnershipCertificate: 'Ortaklık Sertifikası',
			teacherCertificate: 'Öğretmen Sertifikası',
			certificate: 'Sertifika',
			b2bTestCompletionCertificate: 'İngilizce dil testini tamamlama Sertifikası',
		},
		documents: {
			default: 'Belgeler',
		},
		welcomeModal: {
			title: 'Toronto Imperial School Ortak Platformuna Hoş Geldiniz!',
			description: 'Aramızda olmanızdan memnuniyet duyuyoruz.<br /><br />Bu platform, her ortağın tamamlaması gereken temel adımlarda size rehberlik etmek için tasarlanmıştır. Programlarımızı anlamak, temel kaynaklara erişmek ve ailelerle ve öğrencilerle çalışmaya hazır olmak için ihtiyacınız olan her şeyi burada bulacaksınız.<br /><br />Haydi başlayalım!',
			button: 'Başla',
		},
		launchModal: {
			title: '🎓 İlk Eğitim Grubunuzun Başlatılması',
			description: 'Tebrikler — neredeyse geldiniz!<br />İlk öğrenci grubunuz başlamak üzere.<br /><br />Bu sayfada ihtiyacınız olan her şeyi bulacaksınız:<br />✔️ Başlangıç materyalleri<br />✔️ TIS ekibinden destek<br />✔️ Öğrencilerinize rehberlik etmek için adımlar<br /><br />İlham vermeye ve kazanmaya hazır mısınız?<br />Aşağıdaki "Başla" düğmesine tıklayın ve yolculuğunuza başlayalım!<br />',
			button: 'Başla',
		},
		memorandum: {
			title: 'Ortaklık Muhtırası',
			whatIsTitle: 'Ortaklık Muhtırası Nedir?',
			whatIsDescription: 'Ortaklık Muhtırası, TIS platformu aracılığıyla Toronto Imperial School ile akademik işbirliğine olan ilginizi özetleyen basit, bağlayıcı olmayan bir belgedir.<br /> Herhangi bir yasal, mali veya idari yükümlülük <b>oluşturmaz</b>.',
			whyImportantTitle: 'Neden Önemli',
			whyImportantDescription: 'Bu muhtıranın ilkelerini kabul ederek kurumunuz:',
			whyImportantList: {
				item1: 'Öğrencilerinize testler ve tanılamalar sunabilir',
				item2: 'TIS sertifikalı personelle danışmanlıklara, atölyelere ve web seminerlerine erişim kazanır',
				item3: 'Özel akademik araçların, erken kayıt fırsatlarının ve promosyonların kilidini açar',
				item4: 'TIS ekibinden öncelikli destek ve başlangıç desteği alır',
			},
			footer: 'Ücret yok. Formalite yok. Sadece birlikte büyüme fırsatları.',
		},
		partnerAcknowledgementCertificate: {
			title: 'Tebrikler!',
			line1: "Toronto Imperial School'dan resmi Ortak Sertifikasını aldınız",
			line2: 'Artık sertifikalı bir ortak olarak okulu temsil etmeye ve öğrencilerinize en iyi teklifleri sunmaya resmi olarak yetkilisiniz.',
			line3: 'Sertifikanız kişisel panelinizde saklanmaktadır.',
			line4: 'İstediğiniz zaman indirebilir veya talep üzerine sunabilirsiniz. Bu sertifika güvenilir statünüzü ve profesyonel tanınırlığınızı doğrular.',
		},
		teacherCertificate: {
			title: 'Bu, program tamamlama sertifikanızdır.',
			line1: 'Adınıza düzenlenmiştir ve başarılı katılımınızı doğrular.',
			line2: 'Çevrimiçi görüntüleyebilir veya PDF olarak indirebilirsiniz.',
		},
		financialPage: {
			title: 'Finansal Model: Hacim Bazlı Komisyon',
			intro: 'Toronto Imperial School olarak ortaklarımızla Hacim Bazlı Komisyon Modeli kullanarak çalışıyoruz. Bu yaklaşım şeffaf, esnek ve uzun vadeli işbirliğini teşvik eder.',
			b2cTitle: '<t>B2C Fiyatı</t> - öğrenci tarafından ödenen tam program fiyatı. Bu, müşterilerinize tanıttığınız fiyattır.',
			b2bTitle: "<t>B2B Fiyatı</t> - komisyonunuz düşüldükten sonra kuruluşunuzun Toronto Imperial School'a ödediği tutar.",
			howItWorksTitle: 'Nasıl Çalışır',
			howItWorksDescription: 'Ne kadar çok öğrenci kaydettirirseniz, komisyonunuz o kadar yüksek olur. Kayıtlı Öğrenci Sayısı Ortak Komisyonu (B2C fiyatından)',
			row0: '1-4 öğrenci',
			row1: '5-10 öğrenci',
			row2: '11-30 öğrenci',
			row3: '30+ öğrenci',
			commissionNote: 'Komisyonunuz B2C fiyatından hesaplanır.',
			commissionNoteSecond: 'Komisyonu siz alırsınız ve bize B2B fiyatını ödersiniz.',
			exampleTitle: 'Örnek: Program öğretiyorsunuz',
			exampleText1: 'B2C fiyatı öğrenci başına 970 CAD ise, şunu kazanırsınız:',
			exampleText0: '%15 komisyonla öğrenci başına 145 CAD',
			exampleText2: '%30 komisyonla öğrenci başına 290 CAD',
			exampleText3: '%35 komisyonla öğrenci başına 340 CAD',
			exampleText4: '%40 komisyonla öğrenci başına 440 CAD',
			whyItWorksTitle: 'Bu Model Neden İşe Yarar',
			why1: 'Net ve basit yapı — gizli ücret veya karışıklık yok',
			why2: 'Performans bazlı ödüller — ne kadar büyürseniz o kadar kazanırsınız',
			why3: 'Her ortak türü için esnek — okullar, ajanslar, özel dersler veya bireysel eğitimciler için uygundur',
			why4: 'Programlar genelinde ölçeklenebilir — OSSD, Pre-OSSD, UFT için kullanılabilir',
			contactNote: 'Herhangi bir sorunuz varsa Ortak Destek Yöneticinizle iletişime geçmekten çekinmeyin.',
			table: {
				title: 'Birlikte Büyüyelim: Planlar ve Komisyonlar',
				note: '*Programın her katılımcısının 140 CAD kayıt ücretine tabi olduğunu lütfen unutmayın',
				gotQuestion: 'Sorunuz mu var?',
				answer: 'Aşağıdaki düğmeye tıklayın ve talebinizi bırakın — yardımcı olmak için buradayız!',
				button: 'Talep Bırak',
				program: 'Program',
				volume: 'Hacim',
				duration: 'Kurs süresi',
				b2cPrice: 'B2C fiyatı',
				commission: 'Komisyon',
				b2bPrice: 'B2B fiyatı',
				ossdTeacher: 'OSSD öğretmen eşliğinde',
				ossdSelf: 'OSSD kendi hızında',
				preOssd: 'Öğretmenle Pre-OSSD',
				career: 'Kariyer Tasarımı',
				group: 'grup',
				individual: 'bireysel',
			},
		},
		studentsPage: {
			addStudent: 'Öğrenci ekle',
			modalMessage: 'Ya da hızlı bir kayıt bağlantısı paylaşın:',
			uniqueLink: 'Erişimi paylaşmak için benzersiz bir bağlantı oluşturun.',
			copiedAndSent: 'İstediğiniz uygun şekilde kopyalanıp gönderilebilir.',
			generateLinks: 'Bağlantılar oluştur',
		},
		talented: {
			notification: {
				title: 'Mesaj:',
				welcome: 'Talented platformuna hoş geldiniz!',
				message: 'Burada Talented ile çalışma hakkında temel bilgileri bulacaksınız. Ayrıca öğrenci davetleri oluşturabilir, öğrenci ilerlemesini takip edebilir ve öğrenci profillerini görüntüleyebilirsiniz.',
			},
			onboardingHub: {
				step1Title: 'Sertifika ve Memorandum',
				step1Description: 'Ortaklık sertifikalarınızı alın',
				step2Title: 'Eğitim Programları',
				step2Description: 'Ücretsiz ve ücretli ürünleri keşfedin',
				step3Title: 'Finansal Motivasyon',
				step3Description: 'Bonuslar ve komisyonlar hakkında bilgi edinin',
				step4Title: 'Öğrenci Davetleri',
				step4Description: 'Testler için bireysel bağlantılar oluşturun',
				step5Title: 'İlk Grubunuzu Başlatma',
				step5Description: 'Talented ile birlikte öğretmeye başlayın',
				getIt: 'Al',
				detail: 'Daha fazla detay',
			},
			documents: {
				memorandum: 'Niyet Muhtırası',
				partnerCertificate: 'Ortak Sertifikası',
				teacherCertificate: 'Eğitmen / Mentor / Öğretmen Sertifikası',
				b2bPresentation: 'B2B Sunumu',
			},
		},
		events: {
			default: 'Etkinlikler',
		},
	},
	media: {
		preview: 'Önizleme',
		play: 'Oynat',
		dropToUpload:
			'Yüklemek için <FileUploadTextPrimary>dosyayı bırakın</FileUploadTextPrimary>',
		clickToUpload:
			'<FileUploadTextPrimary>Yüklemek için tıklayın</FileUploadTextPrimary> veya sürükleyip bırakın',
		formatPdf500: 'PDF (en fazla 500 MB)',
		formatImageDefault: 'SVG, PNG, JPG veya GIF (en fazla 3 MB)',
		formatChunkFile: 'Görsel, PDF veya Office dosyası (en fazla 100 MB)',
		formatChunkScorm: 'SCORM dosyası (en fazla 762,94 MB)',
		formatVideo500: 'Video dosyası (en fazla 500 MB)',
	},
	common: {
		chat: {
			rules: 'Kurallar',
			continue: 'Devam et',
		},
	},
	tests: {
		default: 'Testler',
		signup: {
			welcome: 'Hoş geldiniz!',
			message: 'Deneme testinize başlamadan önce lütfen hızlı bir kayıt işlemini tamamlayın.',
			startTest: 'Testi başlat',
		},
		cta: {
			submit: '{{slideName}} gönder',
			submitting: 'Gönderiliyor...',
			startTest: 'Testi başlat',
		},
		time: 'Süre',
		test: 'Test',
		modal: {
			title: '📝 Sizin için bir test mevcut {{testName}}',
			message: 'Sizin için yeni bir test mevcut. Odaklanmak ve hazırlanmak için biraz zaman ayırın — uzun sürmeyecek',
			cta: 'Testi başlat',
		},
		modalIELS: {
			title: '{{testName}} kullanılabilir! 🎉',
			p1: 'Test, <bold>"Başla"</bold> düğmesine tıkladıktan hemen <bold>sonra</bold> başlayacaktır.',
			p2: 'İlk sayfada, lütfen test talimatlarını ve detaylarını dikkatlice gözden geçirmek için biraz zaman ayırın — tüm önemli kuralları burada bulacaksınız ✅',
			p3: 'Testi daha sonra almak isterseniz, sağ üst köşedeki <bold>X</bold>’e tıklamanız yeterlidir. Son tarihten önce herhangi bir zamanda ekranın sağ tarafındaki <bold>mavi bayrağa</bold> tıklayarak teste geri dönebilirsiniz.',
			p4: 'Başarılar ✊🏻✨',
			cta: 'Testi başlat',
		},
		thankYouPage: {
			title: 'Tebrikler! 🎉',
			message1: 'Testi tamamladınız! 🌟',
			message2: 'Önümüzde hala önemli miktarda öğrenim olduğunu unutmayın; bu testin amacı, hazırlığınızı bitirmeden önce geliştirebilmeniz için zayıf yönlerinizi ve eksikliklerinizi belirlemektir!',
			pro: {
				welcome: 'Hoş geldiniz, <strong>{{userName}}</strong> 👋',
				yourRIASECResluts: 'RIASEC Sonuçlarınız',
				note: '<strong>Not:</strong> Test sonuçları, testi yaptığınız andaki mevcut durumunuzu, cevaplarınızı ve ruh halinizi yansıtır. Eğilimlerinizin ve ilgi alanlarınızın göstergeleridir, ancak belirli bir meslek veya uzmanlık alanını tanımlamazlar. <br /><br /> Bu sonuçların farklı alanlarda ve faaliyet alanlarında uygulanabileceğini unutmayın. Birçok mesleki alanda gerçekleştirilebilecek güçlü yönlerinizi ve potansiyelinizi anlamak için bir rehber görevi görürler.',
				takeReport: 'Raporunuzu yanınıza alın — tek tıkla PDF hazır.',
				downloadThePdf: 'PDF’i indir',
			},
		},
		results: 'Test sonuçları',
		resultsReview: {
			yourLevel: 'Seviyeniz',
			studentCurrentLevel: 'Öğrencinin mevcut seviyesi',
			recommendedLevel: 'Önerilen seviye',
			yourCertificate: 'Sertifikanız',
			greatJob: 'Harika iş çıkardınız - {{levelShortName}} seviyesine ulaştınız, İngilizcede {{levelLongName}} seviyesi.',
			nextStep: 'Bir sonraki adıma hazırsınız — {{levelShortName}} Seviyesi!',
			nextLearningPath: 'Bir sonraki öğrenim yolunuzu zaten hazırladık.',
			nextLearningPathDescription: 'Yeni dersler, uygulama etkinlikleri ve zorluklar sizi bekliyor. Kelime dağarcığınızı, dilbilgisinizi ve akıcılığınızı birlikte geliştirelim.',
			cta: '{{levelShortName}} yolculuğunuzu şimdi başlatın',
			certificate: 'Sertifika',
			congratulations: '🎉 Tebrikler!',
			certificateSectionText: 'İngilizce seviye testini başarıyla tamamladınız. Sonucunuzu kanıtlamak mı istiyorsunuz? Kişiselleştirilmiş sertifikanızı alın ve becerilerinizi güvenle sergileyin!',
			completionOfAssessment: 'Değerlendirmenin Tamamlanması – Seviye {{level}}',
			completionOfAssessmentTest: 'Harika haber! Bu öğrenci gerekli adımları tamamladı ve yeni programların kilidini açtı.',
			seeCertificate: 'Sertifikayı gör',
			getCertificateCta: 'Sertifikamı Al',
			personalizeModal: {
				title: 'Kişiselleştir',
				text: 'Sertifikanızı kişiselleştirmek için lütfen görünmesini istediğiniz şekilde tam adınızı girin.',
			},
			programProposition: {
				title: 'Program önerisi',
				name: 'Ad',
				cost: 'Maliyet',
				yourCommission: 'Komisyonunuz',
			},
			resultsAnalysis: 'Sonuç analizi',
			certificateModal: {
				title: 'Tebrikler!',
				text: '<strong>Toronto Imperial School</strong> ile <strong>Seviye Tespit Testini</strong> başarıyla tamamladınız — tebrikler!</br></br> Bu, <strong>uluslararası akademik başarıya doğru attığınız ilk adımdır</strong> ve yolculuğunuzun bir parçası olmaktan heyecan duyuyoruz. Sertifikanız artık kişisel panelinizin <strong>“Belgeler”</strong> bölümünde mevcuttur.</br></br> Her adımda size rehberlik etmek ve destek olmak için buradayız.</br></br> Haydi birlikte ilerleyelim! ',
			},
		},
		alreadyRegisteredEmailModal: {
			title: '🔔 Bu e-posta zaten kayıtlı',
			text1: 'Görünüşe göre bu e-posta ile ilişkilendirilmiş bir hesap zaten var. Gelen kutunuza bir test bağlantısı içeren bir mesaj gönderdik.',
			text2: 'Yeni bir hesap oluşturmak isterseniz, lütfen farklı bir e-posta adresi kullanın.',
		},
	},
};

export default LANGUAGE_FILE_TR;
